import styled from 'styled-components';

export const GameJackpotBarLogoDefaultBox = styled.div<{isMobilePortrait?: boolean}>`
    width: ${({isMobilePortrait}) => isMobilePortrait ? '11rem' : '24rem'};
    height: ${({isMobilePortrait}) => isMobilePortrait ? '6.4rem' : '6.7rem'};
    margin-left: ${({isMobilePortrait}) => isMobilePortrait ? '0.3rem' : '1.2rem'};
    margin-top: -1.4rem;
    margin-bottom: -1.4rem;

    background-size: 100%;
    background-position-y: ${({isMobilePortrait}) => isMobilePortrait ? '40%' : '45%'};
    background-repeat: no-repeat, no-repeat;
    background-image: url(${props => props.theme.assets.images.jackpot_bet.jackpot_bet_logo_png.toString()});

    @media ${({theme}) => theme.mediaQuery.mAndAbove + " and " + theme.mediaQuery.lAndBelow} {
        background-size: 80%;
    }
`;